import { useMutation } from "@apollo/client";
import { gql } from "types";

const UPDATE_CITIZENSHIPS = gql(/* GraphQL */ `
  mutation UpdateCitizenships($citizenships: [String!]!) {
    updateCitizenships(citizenships: $citizenships) {
      id
      citizenships
    }
  }
`);

export const useUpdateEmployeeCitizenship = () => {
  const [updateCitizenships, { loading, error }] =
    useMutation(UPDATE_CITIZENSHIPS);

  const updateCitizenship = async (citizenships: string[]) => {
    return updateCitizenships({
      variables: {
        citizenships,
      },
    });
  };

  return {
    updateCitizenship,
    loading,
    error,
  };
};
